"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי לבית המטופל?",
  answer: "אנו מתחייבים למתן מענה מהיר במיוחד. ברוב המקרים, נוכל להציב מטפל סיעודי מקצועי בביתכם בתוך 5 שעות בלבד מרגע הפנייה, כדי להבטיח רצף טיפולי ובטחון מלא."
}, {
  question: "האם המטפלים שלכם עוברים הסמכה מקצועית?",
  answer: "בהחלט. כל צוות המטפלים שלנו עובר סינון קפדני, בדיקת רקע והכשרות מקצועיות בתחומי הסיעוד, העזרה הראשונה והתמיכה הרגשית למבוגרים."
}, {
  question: "מה כולל השירות הסיעודי המיידי?",
  answer: "השירות כולל סיוע בפעולות יומיומיות (ADL), השגחה צמודה, מתן תרופות, ליווי לבדיקות רפואיות ותמיכה פיזית ורגשית המותאמת אישית לצרכי המטופל."
}, {
  question: "האם ניתן לקבל שירות גם בסופי שבוע וחגים?",
  answer: "כן, המוקד שלנו פעיל 24/7. אנו מבינים שמצבי חירום סיעודיים אינם בוחרים זמן, ולכן אנו זמינים לספק פתרונות בכל יום ובכל שעה."
}, {
  question: "איך מתבצע תהליך ההתאמה בין המטפל למטופל?",
  answer: "אנו מבצעים אבחון טלפוני מהיר של צרכי המטופל, מצבו הרפואי והעדפותיו האישיות, ומתאימים לו את המטפל בעל הכישורים והניסיון המתאימים ביותר למקרה הספציפי."
}, {
  question: "האם ישנה התחייבות לתקופה ארוכה?",
  answer: "לא, אנו מציעים גמישות מלאה. ניתן להזמין שירות לטווח קצר (מספר ימים) או לטווח ארוך, בהתאם לצורך המשתנה של המשפחה והמטופל."
}, {
  question: "באילו ערים ניתן לקבל את השירות תוך 5 שעות?",
  answer: "אנו מספקים שירות מהיר בפריסה ארצית רחבה, כולל תל אביב, ירושלים, חיפה, פתח תקווה, ראשון לציון, רמת גן וערים נוספות במרכז ובצפון."
}];
export default function DropCalendarFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223545" id="שאלות-נפוצות" className="bg-background text-foreground py-20 md:py-32 px-6">
      <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground tracking-tight mb-4">
            שאלות ותשובות נפוצות
          </h2>
          <p className="font-default text-lg text-foreground/70 max-w-xl mx-auto">
            כל מה שחשוב לדעת על שירותי הסיעוד המיידיים שלנו והדרך המהירה לקבלת עזרה מקצועית.
          </p>
        </div>

        <div className="bg-card/50 rounded-lg p-6 md:p-10 shadow-md border border-border/50">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/60 py-2">
                <AccordionTrigger className="font-default font-bold text-foreground text-right text-lg md:text-xl hover:no-underline hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-default text-base md:text-lg text-foreground/80 leading-relaxed pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-16 flex flex-col items-center justify-center text-center space-y-6">
          <p className="font-default text-foreground/80 italic">
            זקוקים למטפל סיעודי באופן מיידי?
          </p>
          <Button size="lg" className="font-default font-bold tracking-wide rounded-lg px-10 h-14 text-base shadow-md hover:shadow-lg transition-all bg-primary text-primary-foreground">
            צרו קשר עכשיו
          </Button>
        </div>
      </div>
    </section>;
}